/**
 * ПОЛНЫЙ ПУТЬ: D:\QR\QR-WEB\dashboard\src\components\Business\ExchangeDashboard.jsx
 * ВЕРСИЯ: 2.0 - MARKETPLACE MODEL (DAR)
 * ДАТА: 12.12.2025
 * ОПИСАНИЕ: Курсы DAR - покупка и продажа внутренних единиц
 */

import React, { useState, useEffect } from 'react';
import './ExchangeDashboard.css';
import DepositForm from './DepositForm';
import WithdrawalForm from './WithdrawalForm';

const ExchangeDashboard = () => {
  const [activeTab, setActiveTab] = useState('overview');
  const [rates, setRates] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const token = localStorage.getItem('authToken');
  const API_URL = 'https://qr-money.onrender.com/api/business/exchange';

  useEffect(() => {
    loadExchangeRates();
  }, []);

  const loadExchangeRates = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch(`${API_URL}/rates`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) throw new Error('Ошибка загрузки курсов');
      
      const data = await response.json();
      setRates(data.data);
    } catch (err) {
      setError(err.message || 'Ошибка подключения');
      console.error('❌ [ExchangeDashboard] Error:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="exchange-dashboard">
      <div className="exchange-header">
        <h1>💎 Курсы DAR</h1>
        <p className="subtitle">Покупка и продажа DAR</p>
      </div>

      {/* Курсы */}
      <div className="rates-container">
        {loading ? (
          <div className="loading">Загрузка курсов...</div>
        ) : error ? (
          <div className="error">⚠️ {error}</div>
        ) : rates ? (
          <div className="rates-info">
            <div className="rate-card">
              <div className="rate-label">Купить DAR за EUR</div>
              <div className="rate-value">{rates.rateDeposit?.toFixed(4) || '...'}</div>
              <div className="rate-note">Цена покупки (спред 5%)</div>
            </div>
            <div className="rate-card">
              <div className="rate-label">Продать DAR за EUR</div>
              <div className="rate-value">{rates.rateWithdrawal?.toFixed(4) || '...'}</div>
              <div className="rate-note">Цена продажи (спред 5%)</div>
            </div>
            <div className="rate-card">
              <div className="rate-label">Рыночный курс</div>
              <div className="rate-value">{rates.marketRate?.toFixed(4) || '...'}</div>
              <div className="rate-note">Текущий курс EUR/USDT</div>
            </div>
          </div>
        ) : null}
      </div>

      {/* Табы */}
      <div className="tabs">
        <button 
          className={`tab-btn ${activeTab === 'overview' ? 'active' : ''}`}
          onClick={() => setActiveTab('overview')}
        >
          📊 Обзор
        </button>
        <button 
          className={`tab-btn ${activeTab === 'deposit' ? 'active' : ''}`}
          onClick={() => setActiveTab('deposit')}
        >
          💰 Купить DAR
        </button>
        <button 
          className={`tab-btn ${activeTab === 'withdrawal' ? 'active' : ''}`}
          onClick={() => setActiveTab('withdrawal')}
        >
          💸 Продать DAR
        </button>
      </div>

      {/* Контент табов */}
      <div className="tab-content">
        {activeTab === 'overview' && (
          <div className="overview-tab">
            <div className="info-box">
              <h3>ℹ️ Информация</h3>
              <ul>
                <li><strong>Комиссия банка:</strong> €5 за операцию</li>
                <li><strong>Наш спред:</strong> 5% от суммы</li>
                <li><strong>Мин. покупка:</strong> €500</li>
                <li><strong>Макс. покупка:</strong> €10,000</li>
                <li><strong>Мин. продажа:</strong> 50 DAR</li>
                <li><strong>Требует:</strong> KYC верификация</li>
              </ul>
            </div>
          </div>
        )}

        {activeTab === 'deposit' && (
          <DepositForm onSuccess={loadExchangeRates} token={token} />
        )}

        {activeTab === 'withdrawal' && (
          <WithdrawalForm onSuccess={loadExchangeRates} token={token} />
        )}
      </div>
    </div>
  );
};

export default ExchangeDashboard;